export const baseI18nGetActiveCode = () => {
  const nuxtApp = useNuxtApp()
  const { locale, locales } = nuxtApp.$i18n

  return locales?.value?.find(l => l?.code === locale.value)?.code
}
